import { graphql, useFragment } from 'react-relay';

import {
    useGetPriceAmountByType,
    getEstimatedValueRange,
    type EstimatedValueRange,
} from '../pricingGuidanceHelpers';

import { type useGetEstimatedValueRange_item$key } from './__generated__/useGetEstimatedValueRange_item.graphql';

const itemFragment = graphql`
    fragment useGetEstimatedValueRange_item on Item {
        ...pricingGuidanceHelpers_item
    }
`;

export const useGetEstimatedValueRange = ({
    item: itemRef,
    currency,
}: {
    item: useGetEstimatedValueRange_item$key;
    currency: string;
}): EstimatedValueRange => {
    const item = useFragment(itemFragment, itemRef);

    const medianPrice = useGetPriceAmountByType({ item, currency, type: 'MEDIAN' });

    return getEstimatedValueRange({ medianPrice });
};
